import { identity } from 'lodash';
import { useMemo } from 'react';
import { N_YEARS } from '../../constants/years';
import { useFilterYears, useYearsArray } from '../../utils/hooks';
import { Message } from '../basics/Message';
import MetricsChart from './MetricsChart';
import MetricsPieChart from './MetricsPieChart';

const YearlyMetricsChart = ({ metrics, data, ...chartProps }) => {
  const filterYears = useFilterYears();
  const allYears = useYearsArray(N_YEARS);
  const filteredMetrics = useMemo(() => metrics.filter(({ shown }) => shown), [
    metrics,
  ]);
  const chartData = useMemo(
    () =>
      // Generate metrics for all years and apply filterYears.
      filterYears(
        allYears.map((y, i) => ({
          year: y,
          ...filteredMetrics.reduce(
            (result, { accessor, transform = identity }) =>
              Object.assign(result, {
                [accessor]: transform(data[accessor][i] || 0),
              }),
            {},
          ),
        })),
      ),
    [filterYears, allYears, filteredMetrics, data],
  );

  const hasNoData = useMemo(
    () =>
      !chartData ||
      chartData.length === 0 ||
      filteredMetrics.length === 0 ||
      (chartData.length === 1 &&
        filteredMetrics.every(({ accessor }) => chartData[0][accessor] === 0)),
    [chartData, filteredMetrics],
  );

  return hasNoData ? (
    <Message>No data for current filters</Message>
  ) : chartData.length === 1 ? (
    <MetricsPieChart data={chartData} metrics={filteredMetrics} />
  ) : (
    <MetricsChart data={chartData} metrics={filteredMetrics} {...chartProps} />
  );
};

export default YearlyMetricsChart;
